import { isMacOS } from './platform';

export const getCommand = (cmd: '$mod' | '$shift' | '$alt' | string) => {
  const macOS = isMacOS();

  if (cmd === '$mod') return macOS ? '⌘' : 'Ctrl';
  if (cmd === '$alt') return macOS ? '⌥' : 'Alt';
  if (cmd === '$shift') return macOS ? '⇧' : 'Shift';
  return cmd;
};
